<template>
  <div v-if="drug_suscept" class="card card-content">
    <h6>Drug Sensitivity</h6>
    <form>
      <div class="row">
        <div class="input-field col s12">
          <div class="switch">
            <label>
              Not Done
              <input
                type="checkbox"
                @click="switchChange"
                :checked="drug_suscept.done == 1"
              />
              <span class="lever"></span>
              Done
            </label>
          </div>
        </div>
        <div class="input-field col s12">
          <span>Date of Drug Sensitivity</span>
          <input
            :disabled="drug_suscept.done != 1"
            type="text"
            placeholder="YYYY-MM-DD"
            v-model.lazy="drug_suscept.date"
            class="datepicker"
            readonly
          />
        </div>
        <div class="input-field col s12" v-show="drug_suscept.done == 1">
          <span>Drug Sensitivity Result</span>
          <select v-model="drug_suscept.result">
            <option value="" disabled selected>Choose your option</option>
            <option value="1">H Resistence</option>
            <option value="2">R Resistence</option>
            <option value="3">Z Resistence</option>
            <option value="4">E Resistence</option>
            <option value="5">S Resistence</option>
            <option value="6">Multi Drug Resistence</option>
            <option value="7">Poly Drug Resistence</option>
            <option value="8">Missing</option>
            <option value="9">Pending</option>
          </select>
        </div>

        <div class="row center" v-if="buttonpass">
          <button
            type="button"
            class="btn blue darken-3"
            @click="submit"
            :disabled="updateloading"
          >
            Edit
          </button>
        </div>
      </div>
    </form>
  </div>
  <new-drug-susceptibility v-else></new-drug-susceptibility>
</template>

<script>
import NewDrugSusceptibility from "@/components/Patient/Fill/DrugSusceptibility/NewDrugSusceptibility.vue";
export default {
  name: "DrugSusceptibility",
  data() {
    return {
      done: false,
      date: "",
      result: "",
    };
  },
  components: {
    "new-drug-susceptibility": NewDrugSusceptibility,
  },
  mounted() {
    var elems = document.querySelectorAll("select");
    var instances = M.FormSelect.init(elems, {});

    var elems = document.querySelectorAll(".datepicker");
    var instances = M.Datepicker.init(elems, {
      format: "yyyy-mm-dd",
      showClearBtn: true,
    });
  },
  watch: {},
  methods: {
    switchChange() {
      this.drug_suscept.done = this.drug_suscept.done == 0 ? 1 : 0;
    },

    submit() {
      var data = {
        done: this.drug_suscept.done,
        date: null,
        result: null,
      };

      if (data.done) {
        data.date = this.drug_suscept.date;
        data.result = this.drug_suscept.result;
      }

      data.id = this.patient.id;

      this.$store.dispatch("submitDrugSuscept", data);
    },
  },

  computed: {
    patient() {
      return this.$store.getters.patient;
    },

    drug_suscept() {
      var item = localStorage.getItem("current_data");
      var data = this.$store.getters.patient.drug_suscept;
      if (!item) {
        localStorage.setItem("current_data", JSON.stringify(data));
      }

      return data;
    },

    buttonpass() {
      if (this.drug_suscept.done == 1) {
        if (this.drug_suscept.result && this.drug_suscept.date) {
          return true;
        } else if (this.drug_suscept.result == 9) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    updateloading() {
      return this.$store.getters.updateloading;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fill {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 5px;
}

.fill .card {
  padding: 20px;
}
</style>
